import { render, staticRenderFns } from "./VolumeSlider.vue?vue&type=template&id=4c44d72c"
import script from "./VolumeSlider.vue?vue&type=script&lang=js"
export * from "./VolumeSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports